
import { AppBar, Toolbar, Typography, Button, Box } from '@mui/material';
import './../App.css';
import logo from './../images/logocsf2.PNG';
import backgroundImage from './../images/background_pattern.png'
// import logo from './../images/logo_csf.png';
import React, { useContext } from 'react';
//import { AuthContext } from '../context/AuthContext';
import { useAuth } from "../context/AuthProvider";
import LogoutIcon from '@mui/icons-material/Logout';

type Props = {}

const Header = (props: Props) => {

    //const {authenticated, setAuthenticated,username,setUsername} = useContext(AuthContext)

    const { authenticated, token,  login, logout } = useAuth();

    const handleLogout = () => {
       // localStorage.removeItem("jwt");     
      
        
    }

    return (
        <div>
              {/* style={{ backgroundColor: '#26263f', height: '100px'}}  */}
              {/* backgroundImage: `url('/images/background_pattern.png')`, // URL vers une image locale dans le dossier public */}
              
              <AppBar 
                position="static" 
                elevation={1}
                sx={{
                  height: '100px',
                  backgroundImage: `url(${backgroundImage})`,
                  backgroundPosition: 'center',
                }} > 
                 
                <Toolbar sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', height: '100%' }}>     
                
                  <Box display="flex" alignItems="center">
                    <img src={logo} alt=''  width={80} height={80} />
                  </Box>

                  <Typography  variant="subtitle1"  style={{ textAlign:"center"}}  sx={{ flexGrow: 20 }} >
                    ACCES PARTENAIRES CARTE
                  </Typography>

                 

                  {(authenticated) && 
                    <Button startIcon={<LogoutIcon />} onClick={logout} sx={{ color: "white" }} >
                        Déconnexion
                    </Button> 
                  }

                </Toolbar>
            
              </AppBar>

        </div>

    )

}

export default Header;